exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1tWyGvGIUJJ_HDTBLTjsjK{display:inline-block;width:6px;min-width:6px;vertical-align:middle;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}html[dir=ltr] ._1tWyGvGIUJJ_HDTBLTjsjK{border-top-left-radius:2px;border-bottom-left-radius:2px}html[dir=rtl] ._1tWyGvGIUJJ_HDTBLTjsjK{border-top-right-radius:2px;border-bottom-right-radius:2px}", ""]);

// exports
exports.locals = {
	"bar": "_1tWyGvGIUJJ_HDTBLTjsjK"
};